import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import ChatBot from "../components/chat/ChatBot";
import Summary from "../components/Summary";
import PdfVIew from "../components/PdfVIew";

const HomePage = () => {
  const [searchParams] = useSearchParams();
  const productId = searchParams.get("productid");
  const [isSummaryMaximized, setIsSummaryMaximized] = useState(false);
  const [isChatMaximized, setIsChatMaximized] = useState(false);
  const [isPdfCollapsed, setIsPdfCollapsed] = useState(false);
  // const userId = searchParams.get("uid");
  const userId = useMemo(() => {
    const cs = Cookies.get("competiscaner")?.split(":");
    return cs?.[3];
  }, []);

  const toggleMaximizeSummary = () => {
    if (!isSummaryMaximized) {
      setIsChatMaximized(false);
    }
    setIsSummaryMaximized(!isSummaryMaximized);
  };

  const toggleMaximizeChat = () => {
    if (!isChatMaximized) {
      setIsSummaryMaximized(false);
    }
    setIsChatMaximized(!isChatMaximized);
  };

  const toggleCollapsedPDF = () => {
    if (!isPdfCollapsed) {
      setIsSummaryMaximized(false);
    }
    setIsPdfCollapsed(!isPdfCollapsed);
  };

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex w-100 gap-3">
        <div className={`${isPdfCollapsed ? "pdf-collapsed" : "col-5"}`}>
          <PdfVIew
            productId={productId}
            collapsed={isPdfCollapsed}
            onCollapseClick={toggleCollapsedPDF}
          />
        </div>
        <div className={`${isPdfCollapsed ? "flex-fill" : "flex-fill"}`}>
          <div
            style={{
              height: isSummaryMaximized
                ? "calc(100vh - 110px)"
                : isChatMaximized
                ? "auto"
                : "calc(60vh - 60px)",
              marginBottom: !isChatMaximized ? 0 : "70px",
            }}
          >
            <Summary
              productId={productId}
              maximized={isSummaryMaximized}
              minimized={isChatMaximized}
              onMaximizeClick={toggleMaximizeSummary}
            />
          </div>
          <div
            style={{
              height: isChatMaximized
                ? "calc(100vh - 110px)"
                : isSummaryMaximized
                ? "auto"
                : "40vh",
              marginTop: isChatMaximized ? 0 : "20px",
            }}
          >
            <ChatBot
              productId={productId}
              userId={userId}
              maximized={isChatMaximized}
              minimized={isSummaryMaximized}
              onMaximizeClick={toggleMaximizeChat}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
